import { CardProps } from '@material-ui/core';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import BusinessIcon from '@material-ui/icons/Business';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { calcPatientDetailRoute } from 'app/main/patients/calcPatientDetailRoute';
import { CardX } from 'framework/components/cards/CardX';
import { CaptionVerticalLabelledPropertyX } from 'framework/components/labelledProperty/CaptionVerticalLabelledPropertyX';
import { LabelledPropertyX } from 'framework/components/labelledProperty/LabelledPropertyX';
import { Typography16pxBold } from 'framework/components/typography/Typography16pxBold';
import { formatCurrency } from 'framework/utils/formatCurrency';
import { ITender } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { calcCustomerAccountDetailRoute } from '../../routes';

const Width: number = 280;

interface IProps extends CardProps {
	item: ITender;
	reload: VoidFunction;
}

export const TenderDetailOverviewHeaderCard = ({ item, reload, ...rest }: IProps) => {
	const strings = useLocalization();
	const { push } = useHistory();

	return (
		<CardX
			{...rest}
			className='df-row-wrap gap-16'>
			<div
				className='df-col gap-6'
				style={{ width: Width }}>
				<Typography16pxBold>{strings.totals}</Typography16pxBold>
				<CaptionVerticalLabelledPropertyX label={strings.priceExVat}>{formatCurrency(item.priceExVat)}</CaptionVerticalLabelledPropertyX>
				<CaptionVerticalLabelledPropertyX label={strings.priceInVat}>{formatCurrency(item.priceInVat)}</CaptionVerticalLabelledPropertyX>
			</div>
			{Boolean(item.recipient) && (
				<div
					className='df-col gap-6'
					style={{ width: Width }}>
					<Typography16pxBold>{strings.recipient}</Typography16pxBold>
					<LabelledPropertyX icon={<PersonOutlineIcon />}>{item.recipient.name}</LabelledPropertyX>
					{item.recipient.hasVatNumber && <LabelledPropertyX icon={<BusinessIcon />}>{item.recipient.vatNumber}</LabelledPropertyX>}
					{item.recipient.hasData && (
						<LabelledPropertyX icon={<HomeWorkOutlinedIcon />}>
							<span style={{ whiteSpace: 'pre' }}>{item.recipient.formattedAddressMultipleLines}</span>
						</LabelledPropertyX>
					)}
				</div>
			)}
			<div className='df-col gap-6'>
				<Typography16pxBold>{strings.links}</Typography16pxBold>
				{item.isForPatient && (
					<LabelledPropertyX
						icon={<PersonOutlineIcon />}
						link={() => push(calcPatientDetailRoute(item.forPatient.id!))}>
						{item.forPatient.identifier}
					</LabelledPropertyX>
				)}
				{item.isForCompany && (
					<LabelledPropertyX
						icon={<AccountBalanceWalletOutlinedIcon />}
						link={() => push(calcCustomerAccountDetailRoute(item.forCompany.id!))}>
						{item.forCompany.identifier}
					</LabelledPropertyX>
				)}
			</div>
		</CardX>
	);
};
